module.exports = __webpack_public_path__ + "img/58.251ad422.webp";